import Button from '@atlaskit/button';
import { Checkbox } from '@atlaskit/checkbox';
import React from 'react';
import { CommerceAddress } from '@css-xp/graphtypes';
import { AddressFormSection } from '../../forms';
// import { ENABLE_SAME_AS_BILL_TO } from '@css-xp/types-featureflag';
// import { getFeatureFlag } from '../../../../common/security/selectors';
// import { useSelector } from 'react-redux';

interface Props {
  billToAddress?: CommerceAddress | null;
  shipToAddress?: CommerceAddress | null;
  openBillingModal?: () => void;
  isEditable?: boolean | false;
  shouldDisplayEditOption?: boolean | true;
  setFieldValue?: (name: string, value: unknown) => void;
  isChecked?: boolean | false;
  onSameAsBillTo?: (flag: boolean) => void;
  isShipToAddressViewable?: boolean | true;
  billToAddressHeading?: string;
  isRequired?: boolean;
  hideAddressNameLabel?: boolean;
}

export const BillingDetails = ({
  billToAddress,
  shipToAddress,
  openBillingModal,
  isEditable,
  shouldDisplayEditOption,
  setFieldValue,
  isChecked,
  onSameAsBillTo,
  isShipToAddressViewable = true,
  billToAddressHeading = '',
  isRequired = true,
  hideAddressNameLabel,
}: Props) => {
  const onChangeAsBillTo = () => {
    if (onSameAsBillTo) onSameAsBillTo(!isChecked);
  };

  // const sameAsBillToCheckBoxFeatureFlag = useSelector(
  //     getFeatureFlag(ENABLE_SAME_AS_BILL_TO)
  // );

  return (
    <>
      <div className="bill-to-details">
        <h3>{billToAddressHeading.length > 0 ? billToAddressHeading : 'Bill to address'}</h3>
        {!isEditable && shouldDisplayEditOption && (
          <Button
            appearance="link"
            onClick={openBillingModal}
            className="bill-or-ship-to-edit-link"
            testId="edit-bill-to"
          >
            Edit billing or shipping details
          </Button>
        )}
      </div>
      <AddressFormSection
        isEditable={isEditable}
        {...billToAddress}
        addressName="Bill to"
        setFieldValue={setFieldValue}
        isRequired={isRequired}
        hideAddressNameLabel={hideAddressNameLabel}
      />
      {isShipToAddressViewable && (
        <div className="ship-to-details">
          <h3>Ship to address</h3>
          {!isEditable && shouldDisplayEditOption && (
            <Button
              appearance="link"
              onClick={openBillingModal}
              className="bill-or-ship-to-edit-link"
              testId="edit-ship-to"
            >
              Edit billing or shipping details
            </Button>
          )}
        </div>
      )}

      {
        /* sameAsBillToCheckBoxFeatureFlag && */ isShipToAddressViewable && (
          <div>
            {isEditable && (
              <Checkbox
                isChecked={isChecked}
                data-testId="same-as-shipping-checkbox"
                onChange={onChangeAsBillTo}
                label="Same as bill to address"
                value="Same as bill to address"
                name="same-as-bill-to"
              />
            )}
          </div>
        )
      }

      {isShipToAddressViewable && (
        <AddressFormSection
          isEditable={isEditable}
          {...shipToAddress}
          addressName="Ship to"
          setFieldValue={setFieldValue}
          isRequired={false}
        />
      )}
    </>
  );
};

export default BillingDetails;
